import { format } from "date-fns";
import { Button, Icon, Modal, Typography } from "@/components/atoms";
import { OLD_VM_RETIREMENT_DATE } from "@/constants/vehicleMigration";

interface VehicleMigrationOnboardModalProps {
  open: boolean;
  onClose: () => void;
}

export const VehicleMigrationOnboardModal = ({ open, onClose }: VehicleMigrationOnboardModalProps) => {
  return (
    <Modal open={open} onClose={onClose} className="w-[85vw] !p-6 md:w-[500px]">
      <div className="flex flex-col">
        <Typography variant="h3">Let&apos;s move your vehicles</Typography>
        <Typography variant="paragraph" className="mt-1 text-neutral-dark-gray">
          This vehicle manager retires on <span className="font-semibold text-neutral-black">{format(OLD_VM_RETIREMENT_DATE, "dd MMM yyyy")}</span>
        </Typography>

        <div className="mt-6 flex flex-col divide-y divide-neutral-mid-gray">
          <div className="flex gap-3 pb-5">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-warning/10">
              <Icon name="Danger" variant="Bold" size="sm" className="text-warning" />
            </div>
            <div>
              <Typography variant="action">What happens if you don&apos;t move</Typography>
              <Typography variant="paragraph" className="mt-1 text-neutral-dark-gray">
                Your vehicles and their data will become inaccessible once this manager is retired. Bookings linked to these vehicles may be affected.
              </Typography>
            </div>
          </div>

          <div className="flex gap-3 py-5">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-info/10">
              <Icon name="Timer1" size="sm" className="text-info" />
            </div>
            <div>
              <Typography variant="action">Takes less than 2 minutes for each vehicle</Typography>
              <Typography variant="paragraph" className="mt-1 text-neutral-dark-gray">
                Click Transfer on any vehicle row, fill in a few quick details, and it&apos;s done.
              </Typography>
            </div>
          </div>

          <div className="flex gap-3 pt-5">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-success/10">
              <Icon name="TickCircle" variant="Bold" size="sm" className="text-success" />
            </div>
            <div>
              <Typography variant="action">What&apos;s better in the new manager</Typography>
              <Typography variant="paragraph" className="mt-1 text-neutral-dark-gray">
                Vehicles are mapped more precisely in the new manager, reducing mismatches and making it easier to verify and manage your fleet at a glance.
              </Typography>
            </div>
          </div>
        </div>

        <div className="mt-5 rounded-lg bg-neutral-surface-gray p-3">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            <span className="font-semibold text-neutral-black">What&apos;s moved:</span> My Drivers&apos; Vehicle tab have been moved to the new vehicle manager in the sidebar for easier access.
          </Typography>
        </div>

        <Button variant="primary" size="lg" className="mt-6 w-full" onClick={onClose}>
          View Vehicles
        </Button>
      </div>
    </Modal>
  );
};
